import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import type { ModuleStatesDeclaration } from 'types/StateDeclaration';
import { ReferralDeclineComponent } from './containers/referral-decline/referral-decline.component';
import { ReferralRedirectComponent } from './containers/referral-redirect/referral-redirect.component';

const routes: ModuleStatesDeclaration = {
  states: [
    {
      name: 'referral-decline',
      url: '/referral-decline?token',
      component: ReferralDeclineComponent,
      data: {
        bodyClass: ['app-white']
      }
    },
    {
      name: 'referral-redirect',
      url: '/referral-redirect?url',
      component: ReferralRedirectComponent,
      data: {
        bodyClass: ['app-white']
      }
    }
  ]
};

@NgModule({
  imports: [UIRouterModule.forChild(routes)]
})
export class ReferralRoutingModule {}
